import { Injectable, inject } from '@angular/core';
import { PushPermissionService } from '../../../@commons/@services/webview/push-permission.service';
import { NativeBridgeService } from '../../../@commons/@services/webview/native-bridge.service';
import { ExternalNavigationService } from '../../../@commons/@services/front/external-navigation.service';
import { storeUrlFor } from '../../../@commons/constants/store-urls.constants';

/**
 * L'étape en plus, sans charge : dans l'app, les alertes de gel ; dans le
 * navigateur, où aucune alerte n'arrive, installer l'app ; dans un ancien
 * binaire, qui a déjà posé la question au lancement, rien.
 */
export interface SetupStep {
  kind: 'alerts' | 'install';
  done: boolean;
}

/** « Pour bien démarrer » : l'étape à proposer ici, et son geste. Le premier lancement et le mot du jour la partagent. */
@Injectable({ providedIn: 'root' })
export class SetupStepService {
  private readonly pushPermission = inject(PushPermissionService);
  private readonly bridge = inject(NativeBridgeService);
  private readonly externalNavigation = inject(ExternalNavigationService);

  /** L'étape de cet appareil ; la permission accordée la coche. */
  current(): SetupStep | null {
    if (!this.bridge.isApp) return { kind: 'install', done: false };
    if (!this.pushPermission.isAvailable()) return null;
    return { kind: 'alerts', done: this.pushPermission.status() === 'granted' };
  }

  /** Relit la permission (elle a pu changer dans les réglages du téléphone). */
  refresh(): void {
    if (this.bridge.isApp && this.pushPermission.isAvailable()) void this.pushPermission.refreshStatus();
  }

  open(kind: SetupStep['kind']): void {
    if (kind === 'alerts') {
      // Feuille de permission, ou réglages du téléphone après un refus.
      void this.pushPermission.askFromUser();
    } else {
      this.externalNavigation.redirectTo(storeUrlFor(navigator.userAgent));
    }
  }
}
